import React, { useCallback, useContext,useEffect,useState } from 'react'
import { Typography, Grid, Container, Hidden, useMediaQuery } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import ResponsiveTiles from '../../../../components/layout/ResponsiveTiles'
import ProductItem from '../../../../components/product/ProductItem'
import ShowMore from '../../../../lib/react-storefront/plp/ShowMore'
import Head from 'next/head'
import BackToTop from '../../../../lib/react-storefront/BackToTop'
import { Skeleton } from '@material-ui/lab'
import { Hbox } from '../../../../components/layout/Box'
import LoadMask from '../../../../lib/react-storefront/LoadMask'
import useSearchResultsStore from '../../../../lib/react-storefront/plp/useSearchResultsStore'
import Filter from '../../../../lib/react-storefront/plp/Filter'
import SearchResultsProvider from '../../../../lib/react-storefront/plp/SearchResultsProvider'
import ProductOptionSelector from '../../../../components/option/ProductOptionSelector'
import FilterButton from '../../../../lib/react-storefront/plp/FilterButton'
import SortButton from '../../../../lib/react-storefront/plp/SortButton'
import Fill from '../../../../components/layout/Fill'
import getServerSideAPIProps from '../../../../props/getServerSideAPIProps'
import { FixedSizeGrid as VirtualGrid } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import SessionContext from '../../../../contexts/SessionContext'
import { useRouter } from 'next/router'
const useStyles = makeStyles(theme => ({
  sideBar: {
    margin: theme.spacing(0, 3, 0, 0),
    width: 185,
  },
  sortButton: {
    [theme.breakpoints.down('xs')]: {
      flex: 1,
    },
  },
  total: {
    marginTop: theme.spacing(1),
  },
}))
const ProductRenderer = props => {
  // Access the items array using the "data" prop:
  const product = props.data[props.rowIndex][props.columnIndex]
  return (
    <div style={{ ...props.style, padding: '5px' }}>
      {product && <ProductItem  key={product.id}  product={product} index={product.id} />}
    </div>
  )
}
const Subcategory = lazyProps => {
  const [store, updateStore] = useSearchResultsStore(lazyProps)
  const classes = useStyles()
  const theme = useTheme()
  let { pageData, loading } = store
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
  const isMedium = useMediaQuery(theme.breakpoints.only('md'))
  const isSmall = useMediaQuery(theme.breakpoints.only('sm'))
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'))
  const [addToCartInProgress, setAddToCartInProgress] = useState(false)
  const { session } = useContext(SessionContext)
    if (pageData?.isLanding && pageData.isLanding != undefined) {
    return (
      <>
    
        <Grid item xs={12}>
          {!loading ? (
            <Typography
              component="h1"
              variant="h4"
              gutterBottom
              align="center"
              className={classes.landingTitleSpacing}
            >
              {pageData.name}
            </Typography>
          ) : (
            <Skeleton height={32} style={{ marginBottom: theme.spacing(1) }} />
          )}
        </Grid>
        {!loading && pageData.hasOwnProperty('cmsBlocks') && pageData.cmsBlocks && (
          <LandingCmsSlots cmsBlocks={pageData.cmsBlocks} />
        )}
      </>
    )
  }  
  const cat_filters = pageData?.filters || []

  let cat_filter = []
  let sizefilter = []
  cat_filters.length > 0 &&
    cat_filters.map((val, key) => {
      let fil = val
      if (fil.includes('category:')) {
        let value = val.replace('category:', '')
        if (value != undefined && value.includes('-')) {
          value = value.slice(0, value.indexOf('-'))
        }
        cat_filter.push(value)
      }
      if (fil.includes('size:')) {
        let sizefil = val.replace('size:', '')
        if (sizefil != undefined && sizefil.includes('-')) {
          sizefil = sizefil.slice(0, sizefil.indexOf('-'))
        }
        sizefilter.push(sizefil)
      }
    })

  // Here is an example of how you can customize the URL scheme for filtering and sorting - /subcategory/1?color=red,blue=sort=pop
  // Note that if you change this, you also need to change pages/api/[...categorySlug].js to correctly handle the query parameters
  // you send it.
  const queryForState = useCallback(state => {
    const { q, filters, page, sort } = state
    const query = {}
    cat_filter = []
    sizefilter = []
    for (let filter of filters) {
      const [name, value] = filter.split(':')

      //

      if (query[name]) {
        query[name] = `${query[name]},${value}`
      } else {
        query[name] = value
      }
    }

    if (query.more) {
      delete query.more
    }

    if (page > 0) {
      query.page = page
    } else {
      delete query.page
    }

    if (sort) {
      query.sort = sort
    } else {
      delete query.sort
    }

    if (q) {
      query.q = q
    } else {
      delete query.q
    }

    return query
  }, [])

  return (
    <>
    
      <SearchResultsProvider store={store} updateStore={updateStore} queryForState={queryForState}>
        <Container maxWidth="xl" style={{ paddingTop: theme.spacing(2) }}>
          <Head>{loading ? null : <title>{pageData.title}</title>}</Head>
          <BackToTop />
          <Hbox align="flex-start">
            <Hidden implementation="css" xsDown>
              <div className={classes.sideBar}>
                <Hidden xsDown>
                  {/* Display the filters for desktop screen sizes */}
                  <div className="scroll-blk">
                  <Filter
                      classes={{ root: classes.sideBar, facetGroups: 'hidematches scroll-ht' }}
                      expandAll
                      submitOnChange
                                         />
                  </div>
                </Hidden>
              </div>
            </Hidden>
            <Grid container style={{ position: 'relative' }} className="category-rt">
              <LoadMask show={store.reloading} transparent align="top" />
              <Grid item xs={12}>
                {!loading ? (
                  <Typography component="h1" variant="h6" gutterBottom>
                    {cat_filter.length > 0 ? 'category:(' + cat_filter.join(', ') + ')' : ''}
                    {cat_filter.length > 0 && sizefilter.length > 0 ? ', ' : ''}
                    {sizefilter.length > 0 ? 'size:(' + sizefilter.join(', ') + ')' : ''}
                    {cat_filter.length == 0 && sizefilter.length == 0 ? pageData.name : ''}
                  </Typography>
                ) : (
                  <Skeleton height={32} style={{ marginBottom: theme.spacing(1) }} />
                )}
              </Grid>
              <Grid item xs={6} style={{ paddingRight: theme.spacing(1) }}>
                <Hidden implementation="css" smUp>
                  {/* Display a button that opens the filter drawer on mobile screen sizes */}
                  <FilterButton
                    drawerProps={{ classes: { facetGroups: 'hidematches' } }}
                    style={{ width: '100%' }}
                  />
                </Hidden>
              </Grid>
              <Grid item xs={6} className="hide-small-screen"></Grid>
              <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-start' }}>
              
                <SortButton title='Sort By' className={(classes.sortButton, 'sortButton')} options={pageData?.sortOptions || []} />
              </Grid>
              <Grid
                item
                xs={6}
                style={{ display: 'flex', justifyContent: 'flex-end' }}
                className="total-items"
              >
                {loading ? (
                  <Skeleton
                    width={90}
                    height={14}
                    style={{ marginBottom: 4 }}
                    className={classes.total}
                  />
                ) : (
                  <Typography variant="caption" className={classes.total}>
                    <span>
                      {pageData.total} total {pageData.total === 1 ? 'item' : 'items'}
                    </span>
                  </Typography>
                )}
              </Grid>
              {session.image_edit_allowed ? (
                <Grid item style={{ height: '90vh' }} xs={12} className="catgroup">
                  {!loading ? (
                    <div style={{ height: '100%', width: '100%' }}>
                      <AutoSizer>
                        {({ height, width }) => {
                          let colcount = isDesktop ? 5 : isMedium ? 3 : 2
                          let colwidth = (width - 30) / colcount
                          let rowheight = 0
                          if (session.image_edit_allowed) {
                            rowheight = isDesktop ? 670 : isMedium ? 640 : isSmall ? 500 : 450
                          } else {
                            rowheight = isDesktop
                              ? 450
                              : isMedium
                              ? 450
                              : isSmall
                              ? 420
                              : isExtraSmall
                              ? 350
                              : 400
                          }

                          let allitems = pageData?.products.slice(0)
                          let newProducts = []
                          while (allitems.length) newProducts.push(allitems.splice(0, colcount))
                          return (
                            <VirtualGrid
                              columnCount={colcount}
                              columnWidth={colwidth}
                              height={height}
                              rowCount={newProducts.length}
                              rowHeight={rowheight}
                              width={width}
                              itemData={newProducts}
                            >
                              {ProductRenderer}
                            </VirtualGrid>
                          )
                        }}
                      </AutoSizer>
                    </div>
                  ) : (
                    <ResponsiveTiles cols={{ xs: 2, sm: 1, md: 3, lg: 5, xl: 5 }} spacing={1}>
                      {(() => {
                        const tiles = []
                        for (let i = 0; i < 10; i++) {
                          tiles.push(
                            <div
                              key={i}
                              style={{
                                marginTop: theme.spacing(2),
                                marginBottom: theme.spacing(2),
                              }}
                            >
                              <Fill height="100%" style={{ marginBottom: theme.spacing(1) }}>
                                <Skeleton variant="rect" />
                              </Fill>
                              <Skeleton height={26} />
                              <ProductOptionSelector
                                skeleton={4}
                                variant="swatch"
                                size="small"
                                optionProps={{
                                  size: 'small',
                                  showLabel: false,
                                }}
                              />
                              <Skeleton height={18} />
                              <Skeleton height={24} style={{ marginTop: '5px' }} />
                            </div>
                          )
                        }
                        return tiles
                      })()}
                    </ResponsiveTiles>
                  )}
                </Grid>
              ) : (
                <Grid item xs={12}>
                  {!loading ? (
                    <ResponsiveTiles
                      cols={{ xs: 2, sm: 1, md: 3, lg: 5, xl: 5 }}
                      spacing={1}
                      autoScrollToNewTiles
                    >
                      {pageData?.products?.length > 0 &&
                        pageData.products.map((product, i) => (
                          <ProductItem key={product.id} product={product} index={i} addToCartInProgress={addToCartInProgress} setAddToCartInProgress={setAddToCartInProgress}/>
                        ))}
                    </ResponsiveTiles>
                  ) : (
                    <ResponsiveTiles cols={{ xs: 2, sm: 1, md: 3, lg: 5, xl: 5 }} spacing={1}>
                      {(() => {
                        const tiles = []
                        for (let i = 0; i < 10; i++) {
                          tiles.push(
                            <div
                              key={i}
                              style={{
                                marginTop: theme.spacing(2),
                                marginBottom: theme.spacing(2),
                              }}
                            >
                              <Fill height="100%" style={{ marginBottom: theme.spacing(1) }}>
                                <Skeleton variant="rect" />
                              </Fill>
                              <Skeleton height={26} />
                              <ProductOptionSelector
                                skeleton={4}
                                variant="swatch"
                                size="small"
                                optionProps={{
                                  size: 'small',
                                  showLabel: false,
                                }}
                              />
                              <Skeleton height={18} />
                              <Skeleton height={24} style={{ marginTop: '5px' }} />
                            </div>
                          )
                        }
                        return tiles
                      })()}
                    </ResponsiveTiles>
                  )}
                </Grid>
              )}{' '}
              <Grid item xs={12}>
                {!loading && <ShowMore variant="button" style={{ paddingBottom: 200 }} />}
              </Grid>
            </Grid>
          </Hbox>
        </Container>
      </SearchResultsProvider>
    </>
  )
}

export const getServerSideProps = getServerSideAPIProps('/store/[storeSlug]/subcategory/[...subcategorySlug]')

export default Subcategory